const name = 'FadeIn';
const properties = { schema: {} };
function animate(kit, elements, duration, delay, params) {
    const sequence = kit.sequence(params);
    sequence.add(kit.animate('BaseFade', elements, duration, delay, {
        from: { opacity: 0 },
        to: { opacity: 1 },
        ease: 'sineInOut',
    }));
    return sequence.get();
}
export { name, properties, animate };
//# sourceMappingURL=fadeIn.js.map